<div class="title" *ngIf="title">{{ title }}</div>
<ngx-charts-bar-vertical
  *ngIf="dataList"
  [view]="view"
  [customColors]="customColors"
  [results]="dataList"
  [animations]="false"
  [gradient]="false"
  [xAxis]="true"
  [yAxis]="true"
  [legend]="false"
  [showXAxisLabel]="!!xAxisLabel"
  [showYAxisLabel]="!!yAxisLabel"
  [xAxisLabel]="xAxisLabel"
  [yAxisLabel]="yAxisLabel"
  [showDataLabel]="false"
  [noBarWhenZero]="false"
  [dataLabelFormatting]=""
  [yScaleMax]="yScaleMax"
  [yScaleMin]="yScaleMin"
  [ngStyle]="style$ | async"
  (select)="onSelectChart($event)"
>
</ngx-charts-bar-vertical>
<ngx-charts-bar-vertical-stacked
  *ngIf="chartSeriesDataItem"
  [customColors]="customColors"
  [results]="chartSeriesDataItem"
  [animations]="false"
  [gradient]="false"
  [xAxis]="true"
  [yAxis]="true"
  [legend]="false"
  [showXAxisLabel]="!!xAxisLabel"
  [showYAxisLabel]="!!yAxisLabel"
  [xAxisLabel]="xAxisLabel"
  [yAxisLabel]="yAxisLabel"
  [showDataLabel]="false"
  [noBarWhenZero]="false"
  [ngStyle]="style$ | async"
>
</ngx-charts-bar-vertical-stacked>
